// extracted by mini-css-extract-plugin
export default {"container":"MagazineDetailPage_container__iBs06","header":"MagazineDetailPage_header__jCYpG","title":"MagazineDetailPage_title__MkdnF"};